// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1_FyY","cls2":"PaperImages-cls2_lNe PaperImages-cls1_FyY"};